import { render } from "./Pengguna.vue?vue&type=template&id=54842167"
import script from "./Pengguna.vue?vue&type=script&lang=js"
export * from "./Pengguna.vue?vue&type=script&lang=js"

import "./Pengguna.vue?vue&type=style&index=0&id=54842167&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__